import { RootState } from '../../store/root-state';

export const getBidState = (state: RootState) => state.bid.bid;
